import { helper } from '@ember/component/helper';

export function or(params /*, hash*/) {
  let passes = false;

  for (const param of params) {
    if (param) {
      passes = true;
      break;
    }
  }

  return passes;
}

export default helper(or);
